<template>
  <div class="cartas-proposta-digitacao">
    <g-card
    class="card-form-CartPropDigitacao"
    margem="20px"
    :expansivel="true"
    :comecaFechado="false"
    >
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Cartas-Proposta em Digitação </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="clear"
            />

            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="Grid()"
            >
                BUSCAR
            </g-button>

            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="ExpandeAllRows()"
            v-if="trazBtnExpandirTodos"
            >
              {{ this.valueExpander == 0 ? 'EXPANDIR TODOS' : 'RECOLHER TODOS' }}
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="CartPropDigitacao-conteudo espacamento-filtros">

          <div class="unidade">
              <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
              <PDropDown
                class="unidade-input input-label unidade"
                placeholder="TODAS"
                :options="UnidadeArray"
                v-model="objFiltros.UnidadeId"
                optionLabel="nome"
                optionValue="id"
              />
            </div>

          <div class="filtro-cliente">
            <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
            <div class="cliente-checkbox input-label">
               <!-- <PDropDown
                            class="cliente-input"
                            placeholder="Selecione"
                            :filter="true"
                            :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                            :options="ClienteArray"
                            optionLabel="nomeFantasia"
                            optionValue="id"
                            @filter="buscarClientes($event.value)"
                            emptyMessage="Pesquise o cliente desejado"
                            v-model="objFiltros.ClienteId"
                            >
                                <template #option="slotProps">
                                    <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
                                </template>
                            </PDropDown> -->
                <cliente-dropdown 
                    class="cliente-input"
                    v-model="objFiltros.ClienteId"
                    :empresaId="objFiltros.UnidadeId"
                    :representanteId="this.$store.state.representanteSelecionadoId"
                />

            </div>
          </div>

          <div class="periodo-emissao">
            <div class="periodo-emissao-titulo titulo-conteudo-filtros"> Data de Digitação </div>
            <div class="input-data">
                <div class="data-inicio">
                  <g-date-input
                  class="periodo-emissao-inicio-input input-label"
                  placeholderinput="Início"
                  alturainput = "40px"
                  largurainput = "100%"
                  tamanhobotao = "35px"
                  v-model="objFiltros.DataInicioEmissao"
                  :dataPassadas="true"
                  :retornaDateTime="true"
                  ></g-date-input>
                </div>
                <div class="data-periodo"> à </div>
                <div class="data-termino">
                  <g-date-input
                  class="periodo-emissao-termino-input input-label"
                  placeholderinput="Término"
                  alturainput = "40px"
                  largurainput = "100%"
                  tamanhobotao = "35px"
                  v-model="objFiltros.DataFinalEmissao"
                  :dataPassadas="true"
                  :retornaDateTime="true"
                  ></g-date-input>
              </div>
            </div>
          </div>

          <div class="ordenacao">
            <div class="ordenacao-titulo titulo-conteudo-filtros"> Ordenação </div>
            <div class="ordenacao-checkboxes input-label">
              <div class="data-hora">
                <PCheckBox
                id="data-hora"
                class="checkbox-data-hora"
                :binary="true"
                v-model="objFiltros.OrdenarPorDataHora">
                </PCheckBox>
                <label class="label-checkbox" for="data-hora"> Data e Hora da Carta Proposta </label>
              </div>

            </div>
          </div>

          <div class="buscar-button-filtro">
            <g-button
            class="buscar-button"
            largura="300px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="Grid()"
            >
            BUSCAR
            </g-button>
          </div>
        </div>
      </g-form>
    </g-card>

    <g-card paddingDefault="0 0em 1em"
    class="card-resultado"
    :temCabecalho="false"
    >
      <div v-if="mensagemvazio" class="">
          <img
              class="icone-global-imagemfundo"
              src="@/assets/imgs/Ilustracao_erro.svg"
          />
          <div class="texto-padrao-imagemfundo">
              Verifique os filtros e clique em buscar para exibir os resultados
          </div>
      </div>

      <div v-else-if="!mensagemvazio">
        <g-data-table
        class="datatable-CartPropDigitacao"
        altura="auto"
        TextoVazio="Nenhuma Carta-Proposta encontrada"
        Titulo="Cartas Proposta em digitação"
        :colunas="Colunas"
        :Copiaveis="false"
        :ehExpansivel = "true"
        :maxWidthExpansivel="'100px'"
        :Editavel="false"
        :Filtros="Filtro"
        v-on:excluir="abrePopupExcluir"
        :numeroBotoesAcao="1"
        :Excluivel="true"
        :FiltrosEspecificos = "true"
        :Imprimivel="false"
        :NumeroLinhas="100"
        :Paginacao="true"
        :valores="CartasPropostaDigitacaoArray"
        v-on:duploClickLinha="abrePopup"
        :campoAgrupador="'empresaCliente'"
        :campoExibicaoGrupo="'empresaCliente'"
        :linhasExpandidas="cartasExpandidas"
        >
        <template #expansivel="slotProps">
          <g-data-table
            TextoVazio="Nenhum Orçamento Encontrado"
            Titulo="Orçamento"
            altura="auto"
            :valores="slotProps.linha.data.orcamentos"
            :colunas="ColunasSubGrid"
            :NumeroLinhas="2"
            :Editavel= "false"
            :Imprimivel= "false"
            :rowEditor="false"
            :checkprancheta = "false"
            :esconderColunaFrozen = "true"
            :esconderHeader = "true"
            :FiltrosEspecificos = "false"
            :FiltroGeral = "false"
            :Paginacao="false"
            :bordaDatatable="false"
            dataKey="id"
          >
          </g-data-table>
        </template>
      </g-data-table>

      </div>

      <div class="editar-cartaProp">
        <PDialog :showHeader=false :closable="false" v-model:visible="popup" :modal="true" >
          <div class="conteudo-popup-edicao"> Deseja continuar a editar a Carta-Proposta? </div>
          <div class="editar-informacoes-cartaProp">
            <div class="botao-sim">
              <g-button tipo="cinza" largura="100%" negritoTexto @click="fechaPopup"> NÃO </g-button>
            </div>
            <div class="botao-nao">
              <g-button largura="100%" negritoTexto @click="redireciona"> SIM </g-button>
            </div>
          </div>
        </PDialog>
        <PDialog :showHeader=false :closable="false" v-model:visible="popupExcluir" :modal="true" >
          <div class="conteudo-popup-edicao"> Deseja excluir a Carta-Proposta? </div>
          <div class="editar-informacoes-cartaProp">
            <div class="botao-sim">
              <g-button tipo="cinza" largura="100%" negritoTexto @click="fechaPopupExcluir"> NÃO </g-button>
            </div>
            <div class="botao-nao">
              <g-button largura="100%" negritoTexto @click="excluir(CartaPropostaInfoLinha)"> SIM </g-button>
            </div>
          </div>
        </PDialog>
      </div>
    </g-card>
  </div>
</template>

<script>
import CartaPropostaEmDigitacao from './CartaPropostaEmDigitacao.js'
export default CartaPropostaEmDigitacao
</script>

<style scoped>
.CartPropDigitacao-conteudo {
  margin-top: 20px;
}
.p-dropdown {
    width: 100%;
}
.header-CartPropDigitacao {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.CartPropDigitacao-titulo {
  color: #4f2c19;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.titulo {
  color: #747474;
  text-align: left;
  font-family: Montserrat;
  font-weight: bold;
  padding: 5px 0;
}
.label-checkbox {
  color: #838383;
  text-align: left;
  font-family: Montserrat;
  margin-left: 6px;
}
.periodo-baixa-data, .periodo-emissao-data {
  color: #747474;
  font-family: Montserrat;
}

.input-label {
  margin-bottom: 15px;
}
.consultar-dados, .data-hora ,.numero-carta {
  display: flex;
}

.conteudo-popup-edicao {
  text-align: center;
}

.datatable-CartPropDigitacao {
  border-radius: 10px;
}


.card-resultado-text {
  color: #4f2c19;
  text-align: center;
  font-family: Montserrat;
  margin-top: 10px;
}
.card-resultado-text-small {
  color: #4F4C4D;
  font-family: Montserrat;
}
.imagem-nenhuma-info {
  margin: 0 auto;
  max-height: 500px;
}

.trash-box-carta {
  margin-left: 5px;
}

td, th {
  border: 1px solid #e6e6e6;
  text-align: center;
}

@media (min-width:310px) {
  .CartPropDigitacao-conteudo {
    display: flex;
    flex-direction: column;
    /* padding: 2rem 0; */
  }
.header-CartPropDigitacao {
  display: flex;
}
.CartPropDigitacao-titulo {
  font-size: 18px;
  margin: 0;
}
.buscar-button-header {
  display: none;
  margin-left: 5px;
}

.buscar-button-filtro-carta {
  display: flex;
  justify-content: center;
  align-items: self-end;
}

.titulo {
  font-size: 14px;
}
.label-checkbox {
  font-size: 14px;
}

.cliente-checkbox {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(3, auto);
  grid-row-gap: 10%;
}
.periodo-baixa-input {
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: 100%;
  grid-column-gap: 4%;
}
.periodo-baixa-inicio { grid-area: 1 / 1 / 2 / 2; }
.periodo-baixa-data { grid-area: 1 / 2 / 2 / 3; align-self: center; }
.periodo-baixa-termino { grid-area: 1 / 3 / 2 / 4; }

.periodo-emissao-input {
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: 100%;
  grid-column-gap: 4%;
}
.periodo-emissao-inicio { grid-area: 1 / 1 / 2 / 2; }
.periodo-emissao-data { grid-area: 1 / 2 / 2 / 3; align-self: center; }
.periodo-emissao-termino { grid-area: 1 / 3 / 2 / 4; }

.ordenacao-checkboxes {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(2, auto);
  grid-row-gap: 10%;
}

.numero-solicitacao-input, .numero-cartaProp-input, .produto-input, .produto-novo-input, .empresa-input, .unidade-input ,.cliente-input, .status-input {
  width: 100%;
}


.imagem-nenhuma-info {
  height: 8rem;
  width: auto;
}

.CartPropDigitacao-titulo {
  font-size: 18px;
  margin-left: 10px;
}
.card-resultado-text {
  font-size: 15px;
}
.card-resultado-text-small {
  font-size: 14px;
}

.datatable-CartPropDigitacao {
  text-align: center;
}

.editar-cartaProp {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: repeat(2, auto);
  grid-row-gap: 2%;
}
.conteudo-popup-edicao {
  grid-area: 1 / 1 / 2 / 2;
  color: #4E4E4E;
  text-align: center;
  font-weight: 600;
  font-family: 'MontSerrat';
  margin-top: 25px;
  margin-bottom: 15px;
}
.editar-informacoes-cartaProp {
  grid-area: 2 / 1 / 3 / 2;
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: 100%;
  grid-column-gap: 5%;
}
.botao-sim { grid-area: 1 / 1 / 2 / 2; }
.botao-nao { grid-area: 1 / 2 / 2 / 3; }
}

@media (min-width:368px) {
.buscar-button-carta {
  width: 60%;
}
.imagem-nenhuma-info {
  height: 10rem;
  width: auto;
}
}

@media (min-width:600px) {
  .CartPropDigitacao-conteudo {
    display: grid;
    grid-template-columns: 50% minmax(6em, 1fr);
    grid-template-rows: repeat(2, auto);
    grid-column-gap: 15px;
    grid-row-gap: 0px;
  }
.header-icons-CartPropDigitacao {
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: 100%;
  grid-column-gap: 10px;
}

.CartPropDigitacao-titulo {
  margin-left: 20px;
}
.buscar-button-header {
  display: block;
}
.buscar-button-carta {
  display: none;
}

.imagem-nenhuma-info {
  height: 14rem;
  width: auto;
}


.buscar-button-filtro-carta {
  display: none;
}
}

@media (min-width:801px) {
.CartPropDigitacao-titulo {
  font-size: 20px;
}



}

@media (min-width:1025px) {
  .CartPropDigitacao-conteudo {
    display: grid;
    grid-template-columns: 30% 20% minmax(6em, 1fr) minmax(6em, 1fr);
    grid-template-rows: repeat(1, auto);
    grid-column-gap: 20px;
    grid-row-gap: 0px;
  }
.CartPropDigitacao-titulo {
  font-size: 22px;
}
.card-resultado-text {
  font-size: 16px;
}
.card-resultado-text-small {
  font-size: 14px;
}
.imagem-nenhuma-info {
  height: 16rem;
  width: auto;
}




}

@media (min-width:1281px) {

}

@media (min-width:1500px) {


}
</style>